import * as Sentry from '@sentry/browser';

Sentry.init({
  dsn: 'https://99cc7eb81c89413c9d0eb27934f2ea70@sentry.io/1510065',
});
